var render, staticRenderFns
import script from "./scraplist.vue?vue&type=script&lang=js&"
export * from "./scraplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2e5931",
  null
  
)

export default component.exports